
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenSyncLocation {

    iso31663: string;
    name: string;
    type: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genSyncLocation: GenSyncLocation);

    constructor( input?: GenSyncLocation ) {
        if ( input && typeof input !== 'number' ) {
            this.iso31663 = input.iso31663; // string [string]
            this.name = input.name; // string [string]
            this.type = input.type; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenSyncLocation[] {
        if (arr && arr.map) {
          return arr.map(a => new GenSyncLocation(a));
        } else {
          return [];
        }
    }
}

